import React, { useState } from 'react';
import CallLogPage from './CallLogPage';
import TrackedNumbersPage from './TrackedNumbersPage';
import CallingModePage from './CallingModePage';
import VoipPage from './VoipPage';
import FaxPage from './FaxPage';
import FrontDeskInboxPage from './FrontDeskInboxPage';

// TelephonyHubPage consolidates 6 separate phone-related pages into one
// workspace with internal tabs. Same pattern as PharmacyPage / WhatsAppHubPage.
// Legacy hub keys (call-log, tracked-numbers, calling-mode, voip, fax,
// frontdesk-inbox) all resolve here via `initialTab`.
const TELE_TABS = [
  { key: 'callLog',     label: 'Call Log',         render: (props) => <CallLogPage {...props} /> },
  { key: 'tracked',     label: 'Call Tracking',    render: (props) => <TrackedNumbersPage {...props} /> },
  { key: 'callingMode', label: 'Calling Mode',     render: (props) => <CallingModePage {...props} /> },
  { key: 'voip',        label: 'VoIP',             render: (props) => <VoipPage {...props} /> },
  { key: 'fax',         label: 'eFax',             render: (props) => <FaxPage {...props} /> },
  { key: 'frontDesk',   label: 'AI Front Desk',    render: (props) => <FrontDeskInboxPage {...props} /> },
];

const LEGACY_MAP = {
  'call-log':         'callLog',
  'tracked-numbers':  'tracked',
  'calling-mode':     'callingMode',
  'voip':             'voip',
  'fax':              'fax',
  'frontdesk-inbox':  'frontDesk',
};

const TelephonyHubPage = ({ API_BASE, patientsList, currentUser, initialTab = 'callLog' }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = TELE_TABS.find(t => t.key === tab) || TELE_TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {TELE_TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.82rem',
              backgroundColor: tab === t.key ? '#F97316' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {Active.render({ API_BASE, patientsList, currentUser })}
    </div>
  );
};

export default TelephonyHubPage;
